import { render, staticRenderFns } from "./msMessageNotification.vue?vue&type=template&id=1aac18eb&scoped=true"
import script from "./msMessageNotification.vue?vue&type=script&lang=js"
export * from "./msMessageNotification.vue?vue&type=script&lang=js"
import style0 from "./msMessageNotification.vue?vue&type=style&index=0&id=1aac18eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aac18eb",
  null
  
)

export default component.exports